class Helper {
  constructor(factory) {
    this.factory = factory;
  }

  /**
   *
   * @param {Team} team
   * @param {number|string|null} [week]
   * @returns {TeamLogo}
   */
  getTeamLogo(team, week) {
    const teamLogos = this.factory.makeTeamLogoCollection(team);
    return !!week ? teamLogos.getLogoByWeek(week) : teamLogos.getActiveLogo();
  }

  /**
   *
   * @param {Team} team
   * @param {string|number|null} [week]
   * @param {string} [size="lg"]
   * @param {string} [linkPath]
   * @param {object} [styleProps={}]
   * @returns {JSX.Element}
   */
  getTeamLogoImg(team, week, size, linkPath, styleProps = {}) {
    const teamLogo = this.getTeamLogo(team, week);
    if (linkPath) return teamLogo.getImgLink(linkPath, size);
    return teamLogo.getImg(size, styleProps);
  }

  /**
   *
   * @param {User} user
   * @param {TeamCollection} teams
   * @returns {Team[]}
   */
  getTeamsForUser(user, teams) {
    return teams.items.filter((team) =>
      team.obj.roles.hasOwnProperty(user.obj.username)
    );
  }
}

export default Helper;
